(function () {
    'use strict';

    var $ = window.jQuery;
    var tthis;
    var results = 0;

    function SearchFacility() {
        tthis = this;
        this.initActions();
        this.initSearch();
    }

    SearchFacility.prototype.initSearch = function () {
        $('#facility_search').on('keyup', this.inputChanged);
    };

    SearchFacility.prototype.initActions = function () {

        var searchInput = $('#facility_search');
        var searchResults = $('#search_results');
        searchInput.on('focus', function () {
            if (results > 0) {
                searchResults.slideDown(300);
            }
        });

        searchInput.on('blur', function () {
            searchResults.slideUp(300);
        });

    };

    SearchFacility.prototype.inputChanged = function (event) {
        var searchValue = $(event.target).val();
        delay(function () {
            if (searchValue.length >= 3) {
                tthis.sendRequest(searchValue);
            }
        }, 500);
    };

    var delay = (function () {
        var timer = 0;
        return function (callback, ms) {
            clearTimeout(timer);
            timer = setTimeout(callback, ms);
        };
    })();

    SearchFacility.prototype.sendRequest = function (searchValue) {
        var request_data = {'search_value': searchValue};
        var searchResults = $('#search_results');

        $.ajax({
            type: 'GET',
            url: '/wp-json/arkansas/v2/search_facility',
            data: request_data,
            beforeSend: function () {
                searchResults.css({'display': 'none'});
            },
            success: function (response) {
                searchResults.empty();
                results = Object.keys(response).length;

                $.each(response, function (title, link) {
                    searchResults.append('<li><a href="' + link + '">' + title + '</a></li>');
                    searchResults.slideDown(300);
                });
            },
            error: function (data) {
            }
        });
    };

    window.SearchFacility = SearchFacility;

}());